// Marker in Notizen (Runde 7B): Close nimmt in Notizen nur a, br, span, img, i, b, u, s, strike, em (und Listen, Zitat, Absätze), kein `<mark>`
// (am Testlead am 17.10.2026 geprüft: „Element 'mark' is not expected“). Der Editor arbeitet deshalb mit `<mark>`, gespeichert wird ein
// `<span style="background-color: …">`; beim Anzeigen und Bearbeiten geht es zurück. Der Schutz `sicheresHtml` entfernt Stile, daher
// wird vor dem Reinigen umgewandelt.
const MARKER_FARBE = "#ffe58a";

/** `<span style="background-color…">` (und Ähnliches) -> `<mark>`; die schließenden Tags bleiben `</span>` und werden mitgezählt */
export function markerZuMark(html: string): string {
  if (!html || !/background|highlight|marker|mark/i.test(html)) return html;
  const doc = new DOMParser().parseFromString(`<!doctype html><body>${html}</body>`, "text/html");
  for (const el of Array.from(doc.body.querySelectorAll("span"))) {
    const stil = el.getAttribute("style") ?? "";
    const klasse = el.getAttribute("class") ?? "";
    const farbe = /background(?:-color)?\s*:\s*([^;]+)/i.exec(stil)?.[1]?.trim() ?? "";
    if (farbe || /highlight|marker|mark/i.test(klasse)) {
      if (/^(transparent|inherit|initial|unset|none)$|rgba\(\s*0\s*,\s*0\s*,\s*0\s*,\s*0\s*\)/i.test(farbe)) {
        el.replaceWith(...Array.from(el.childNodes)); // Marker entfernt: nur noch die leere Hülle
      } else {
        const m = doc.createElement("mark");
        m.append(...Array.from(el.childNodes));
        el.replaceWith(m);
      }
    }
  }
  return doc.body.innerHTML;
}

/** `<mark>` -> `<span style="background-color: #ffe58a">` für Close */
export function markZuSpan(html: string): string {
  return html.replace(/<mark>/gi, `<span style="background-color: ${MARKER_FARBE}">`).replace(/<\/mark>/gi, "</span>");
}
